"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.innerGetDeploymentError = innerGetDeploymentError;
exports.innerGetDeploymentOperations = innerGetDeploymentOperations;
const pageSize = 100;
async function innerGetDeploymentError(client, resourceGroupName, deploymentName) {
    return client.deployments.get(resourceGroupName, deploymentName);
}
async function innerGetDeploymentOperations(client, resourceGroupName, deploymentName) {
    const res = [];
    for await (const page of client.deploymentOperations
        .list(resourceGroupName, deploymentName)
        .byPage({ maxPageSize: pageSize })) {
        res.push(...page);
    }
    return res;
}
//# sourceMappingURL=innerHandleError.js.map